import { camelizeKeys } from '~/redux/api/transformers/utils';
import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

import { DataWrapper } from '../../ApiTypes';
import { GroupServer, UpdateGroupPayload } from './types';

export interface UpdateGroupParams extends UpdateGroupPayload {
  id: string;
}

export const updateGroup = async (
  params: UpdateGroupParams,
  options: ServiceRequestConfig = {},
) => {
  const { id, ...group } = params;
  const response = await managedEntities.patch<DataWrapper<GroupServer>>(
    `/groups/${id}`,
    group,
    { showErrorToast: true, ...options },
  );
  return camelizeKeys(response.data);
};
